import React from "react";
import amazonIcon from "../../assets/payment-methods/amazon.png";
import amexIcon from "../../assets/payment-methods/amex.png";
import cirrusIcon from "../../assets/payment-methods/cirrus.png";
import dinersClubIcon from "../../assets/payment-methods/diners-club.png";
import directDebitIcon from "../../assets/payment-methods/direct-debit.png";
import discoverIcon from "../../assets/payment-methods/discover.png";
import ebayIcon from "../../assets/payment-methods/ebay.png";
import ewayIcon from "../../assets/payment-methods/eway.png";
import genericWavesIcon from "../../assets/payment-methods/generic-waves.png";
import googleWalletIcon from "../../assets/payment-methods/google-wallet.png";
import jcbIcon from "../../assets/payment-methods/jcb.png";
import maestroIcon from "../../assets/payment-methods/maestro.png";
import mastercardIcon from "../../assets/payment-methods/mastercard.png";
import moneybookersIcon from "../../assets/payment-methods/moneybookers.png";
import paypalIcon from "../../assets/payment-methods/paypal.png";
import sageIcon from "../../assets/payment-methods/sage.png";
import shopifyIcon from "../../assets/payment-methods/shopify.png";
import skrillIcon from "../../assets/payment-methods/skrill.png";
import soloIcon from "../../assets/payment-methods/solo.png";
import stripeIcon from "../../assets/payment-methods/stripe.png";
import visaIcon from "../../assets/payment-methods/visa.png";
import visaElectronIcon from "../../assets/payment-methods/visa-electron.png";
import westernUnionIcon from "../../assets/payment-methods/western-union.png";
import worldpayIcon from "../../assets/payment-methods/worldpay.png";
import styles from "../../styles/BillingPage.module.css";

const formatCardType = (brand) => {
  const value = String(brand || "").trim();
  if (!value) return "Card";
  return value.charAt(0).toUpperCase() + value.slice(1);
};

const getCardIcon = (brand) => {
  const normalized = String(brand || "").toLowerCase().trim();
  const compact = normalized.replace(/[\s_-]+/g, "");

  const icons = {
    amazon: amazonIcon,
    amex: amexIcon,
    americanexpress: amexIcon,
    cirrus: cirrusIcon,
    diners: dinersClubIcon,
    dinersclub: dinersClubIcon,
    directdebit: directDebitIcon,
    discover: discoverIcon,
    ebay: ebayIcon,
    eway: ewayIcon,
    genericwaves: genericWavesIcon,
    googlepay: googleWalletIcon,
    googlewallet: googleWalletIcon,
    jcb: jcbIcon,
    maestro: maestroIcon,
    mastercard: mastercardIcon,
    moneybookers: moneybookersIcon,
    paypal: paypalIcon,
    sage: sageIcon,
    shopify: shopifyIcon,
    skrill: skrillIcon,
    solo: soloIcon,
    stripe: stripeIcon,
    visa: visaIcon,
    visaelectron: visaElectronIcon,
    westernunion: westernUnionIcon,
    worldpay: worldpayIcon,
  };

  return icons[compact] || null;
};

export default function CardBrandIcon({ brand }) {
  const icon = getCardIcon(brand);

  if (icon) {
    return (
      <img
        src={icon}
        alt={formatCardType(brand)}
        className={styles.CardBrandImage}
      />
    );
  }

  return (
    <span className={styles.CardBrandGeneric}>
      {formatCardType(brand)}
    </span>
  );
}
